import { render, staticRenderFns } from "./downloads.vue?vue&type=template&id=22e79fb8&scoped=true&lang=pug"
import script from "./downloads.vue?vue&type=script&lang=js"
export * from "./downloads.vue?vue&type=script&lang=js"
import style0 from "./downloads.vue?vue&type=style&index=0&id=22e79fb8&prod&lang=scss&scoped=true"
import style1 from "./downloads.vue?vue&type=style&index=1&id=22e79fb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e79fb8",
  null
  
)

export default component.exports